import './ProductsMenu.scss';

import cn from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';

import { useNodesTreeContext } from '@/common/contexts/NodesTreeContext/NodesTreeContext';
import useFormattedNodesTree from '@/common/hooks/nodes/useFormattedNodesTree';
import useBreakpoints from '@/common/hooks/useBreakpoints';
// eslint-disable-next-line import/no-cycle
import MobileMenu from '@/ebat/components/blocks/Header/MobileMenu/MobileMenu';
import useMenuWidth from '@/ebat/components/blocks/Header/ProductsMenu/useMenuWidth';
import {
  MENU_NAME_MOBILE,
  MENU_TYPE_DRAWER,
  useHeaderMenuContext,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

import ProductList from './ProductList/ProductList';
import {
  ProductsMenuDefaultProps,
  ProductsMenuPropTypes,
} from './ProductsMenu.proptypes';

const getSelectedCategories = (categories, selectedItem, isMaxDesktop) => {
  let selectedCategories = [categories];
  categories?.forEach((category) => {
    const isSelected =
      !isMaxDesktop &&
      selectedItem &&
      (category.id === selectedItem.id ||
        selectedItem.parents.indexOf(category.id) !== -1);
    if (isSelected && category.children && category.children.length > 0) {
      selectedCategories = [
        ...selectedCategories,
        ...getSelectedCategories(category.children, selectedItem, isMaxDesktop),
      ];
    }
  });

  return selectedCategories;
};

const ProductsMenu = ({ className }) => {
  const { handleClose, handleOpen } = useHeaderMenuContext();
  const { nodesTree, isSuccess } = useNodesTreeContext();
  const prevIsMaxDesktop = useRef(null);
  const { isMaxDesktop } = useBreakpoints();

  const {
    formattedData,
    selectedItem,
    handleSelection: handleNodeSelection,
  } = useFormattedNodesTree(nodesTree, isSuccess, handleClose);
  const flatTree = useMemo(
    () => getSelectedCategories(formattedData, selectedItem, isMaxDesktop),
    [formattedData, isMaxDesktop, selectedItem],
  );
  const { panelWidth } = useMenuWidth(flatTree.length);

  useEffect(() => {
    if (isMaxDesktop !== prevIsMaxDesktop.current) {
      if (prevIsMaxDesktop.current !== null) {
        handleClose();
      }
      prevIsMaxDesktop.current = isMaxDesktop;
    }
  }, [handleClose, isMaxDesktop]);

  const handleSelection = (node) => {
    if (node === undefined) {
      handleOpen(MENU_NAME_MOBILE, MENU_TYPE_DRAWER, 'left', <MobileMenu />);
    } else {
      handleNodeSelection(node);
    }
  };

  if (!isSuccess) return null;

  return (
    <div className={cn(className, 'products-menu')} data-qa-id="products-menu">
      {flatTree.map((categories, i) => (
        <ProductList
          key={i}
          className="products-menu__list"
          isOpen
          isRoot={i === 0}
          items={categories}
          panelWidth={panelWidth}
          panelIndex={i}
          parent={categories?.[0]?.parent ?? null}
          selectedItem={selectedItem}
          onSelect={handleSelection}
        />
      ))}
    </div>
  );
};

ProductsMenu.defaultProps = {
  ...ProductsMenuDefaultProps,
};

ProductsMenu.propTypes = {
  ...ProductsMenuPropTypes,
};

export default ProductsMenu;
